/*
 * Olszyna Motopark - zachowania interfejsu.
 *
 * Zastepuje to, co w poprzedniej wersji robil React + framer-motion:
 *  - stan paska nawigacji po przewinieciu strony,
 *  - menu mobilne,
 *  - dolny pasek (sticky bottom bar),
 *  - wskaznik "Scroll" pod heroem,
 *  - animacje wejscia sekcji (odpowiednik whileInView),
 *  - karuzela opinii (przyciski w lewo/prawo),
 *  - plynne przewijanie do kotwic (#cennik, #harmonogram, ...).
 *
 * Skrypt jest odporny na wielokrotne wywolanie - dziala tez w edytorze motywu,
 * gdzie Shopify przeladowuje pojedyncze sekcje (shopify:section:load).
 */
(function () {
  'use strict';

  var SCROLL_RATIO = 0.2; // window.innerHeight * 0.2 - taki sam prog jak w Reakcie
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------
   * Wspolny nasluch scrolla (jeden listener zamiast kilku)
   * ---------------------------------------------------------------- */
  var scrollHandlers = [];
  var scrollScheduled = false;

  function onScroll() {
    if (scrollScheduled) return;
    scrollScheduled = true;
    window.requestAnimationFrame(function () {
      scrollScheduled = false;
      for (var i = 0; i < scrollHandlers.length; i++) {
        try {
          scrollHandlers[i]();
        } catch (e) {
          /* pojedynczy blad nie moze zabic pozostalych */
        }
      }
    });
  }

  function addScrollHandler(fn) {
    scrollHandlers.push(fn);
    fn();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ----------------------------------------------------------------
   * Pasek nawigacji
   * ---------------------------------------------------------------- */
  function initNavbar(root) {
    var nav = root.querySelector('[data-om-navbar]');
    if (!nav || nav.dataset.omNavbarReady === 'true') return;
    nav.dataset.omNavbarReady = 'true';

    var logo = nav.querySelector('[data-om-navbar-logo]');
    var scrolledNavClasses = (nav.dataset.omScrolledClass || '').split(' ').filter(Boolean);
    var topNavClasses = (nav.dataset.omTopClass || '').split(' ').filter(Boolean);
    var scrolledLogoClasses = logo ? (logo.dataset.omScrolledClass || '').split(' ').filter(Boolean) : [];
    var topLogoClasses = logo ? (logo.dataset.omTopClass || '').split(' ').filter(Boolean) : [];
    var isScrolled = null;

    addScrollHandler(function () {
      var next = window.scrollY > window.innerHeight * SCROLL_RATIO;
      if (next === isScrolled) return;
      isScrolled = next;

      nav.classList.toggle('is-scrolled', next);
      applyClasses(nav, next ? scrolledNavClasses : topNavClasses, next ? topNavClasses : scrolledNavClasses);
      if (logo) {
        applyClasses(logo, next ? scrolledLogoClasses : topLogoClasses, next ? topLogoClasses : scrolledLogoClasses);
      }
    });

    initMobileMenu(root, nav);
  }

  function applyClasses(el, add, remove) {
    var i;
    for (i = 0; i < remove.length; i++) el.classList.remove(remove[i]);
    for (i = 0; i < add.length; i++) el.classList.add(add[i]);
  }

  /* ----------------------------------------------------------------
   * Menu mobilne
   * ---------------------------------------------------------------- */
  function initMobileMenu(root, nav) {
    var toggle = nav.querySelector('[data-om-menu-toggle]');
    var menu = root.querySelector('[data-om-mobile-menu]');
    if (!toggle || !menu) return;

    var iconOpen = toggle.querySelector('[data-om-icon-open]');
    var iconClose = toggle.querySelector('[data-om-icon-close]');

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('om-menu-open', open);
      if (iconOpen) iconOpen.hidden = open;
      if (iconClose) iconClose.hidden = !open;
    }

    toggle.addEventListener('click', function () {
      setOpen(menu.hidden);
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a, button')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) setOpen(false);
    });

    setOpen(false);
  }

  /* ----------------------------------------------------------------
   * Dolny pasek
   * ---------------------------------------------------------------- */
  function initStickyBar(root) {
    var bar = root.querySelector('[data-om-sticky]');
    if (!bar || bar.dataset.omReady === 'true') return;
    bar.dataset.omReady = 'true';

    addScrollHandler(function () {
      bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * SCROLL_RATIO);
    });
  }

  /* ----------------------------------------------------------------
   * Wskaznik "Scroll" - zanika miedzy 0 a 300 px (jak useTransform)
   * ---------------------------------------------------------------- */
  function initScrollIndicator(root) {
    var indicators = root.querySelectorAll('[data-om-scroll-indicator]');
    if (!indicators.length) return;

    Array.prototype.forEach.call(indicators, function (el) {
      if (el.dataset.omReady === 'true') return;
      el.dataset.omReady = 'true';
      addScrollHandler(function () {
        var progress = Math.min(Math.max(window.scrollY / 300, 0), 1);
        el.style.opacity = String(1 - progress);
      });
    });
  }

  /* ----------------------------------------------------------------
   * Animacje wejscia sekcji (odpowiednik framer-motion whileInView)
   * ---------------------------------------------------------------- */
  var revealObserver = null;
  var revealPending = [];

  function reveal(el) {
    el.classList.add('is-in');
    if (revealObserver) revealObserver.unobserve(el);
    var i = revealPending.indexOf(el);
    if (i > -1) revealPending.splice(i, 1);
  }

  function getRevealObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    // Bez `rootMargin` - tak samo jak framer-motion `whileInView` w wersji React.
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      },
      { threshold: 0 }
    );
    return revealObserver;
  }

  function initReveals(root) {
    var items = root.querySelectorAll('.om-reveal:not([data-om-ready])');
    if (!items.length) return;

    var observer = getRevealObserver();
    Array.prototype.forEach.call(items, function (el) {
      el.dataset.omReady = 'true';
      if (!observer || prefersReducedMotion) {
        el.classList.add('is-in');
        return;
      }
      revealPending.push(el);
      observer.observe(el);
    });
    sweepReveals();
  }

  // Zabezpieczenie: przy bardzo szybkim przewijaniu (albo skoku klawiszem End)
  // IntersectionObserver potrafi nie zdazyc zaraportowac elementu. Tutaj po prostu
  // sprawdzamy, czy element juz wjechal w obszar okna.
  function sweepReveals() {
    if (!revealPending.length) return;
    for (var i = revealPending.length - 1; i >= 0; i--) {
      var el = revealPending[i];
      if (el.getBoundingClientRect().top < window.innerHeight) reveal(el);
    }
  }

  addScrollHandler(sweepReveals);
  window.addEventListener('load', sweepReveals);

  /* ----------------------------------------------------------------
   * Karuzela opinii
   * ---------------------------------------------------------------- */
  function initCarousels(root) {
    var carousels = root.querySelectorAll('[data-om-carousel]');
    Array.prototype.forEach.call(carousels, function (carousel) {
      if (carousel.dataset.omReady === 'true') return;
      carousel.dataset.omReady = 'true';

      var track = carousel.querySelector('[data-om-carousel-track]');
      var prev = carousel.querySelector('[data-om-carousel-prev]');
      var next = carousel.querySelector('[data-om-carousel-next]');
      if (!track) return;

      var enabledClasses = ['border-neon', 'text-neon', 'hover:bg-neon', 'hover:text-carbon-dark', 'cursor-pointer'];
      var disabledClasses = ['border-white/10', 'text-white/20', 'cursor-not-allowed'];

      function step() {
        var width = track.clientWidth;
        if (window.innerWidth >= 1024) return width / 3;
        if (window.innerWidth >= 768) return width / 2;
        return width * 0.8;
      }

      function refresh() {
        var canLeft = track.scrollLeft > 5;
        var canRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 10;
        setButton(prev, canLeft);
        setButton(next, canRight);
      }

      function setButton(button, enabled) {
        if (!button) return;
        button.disabled = !enabled;
        applyClasses(button, enabled ? enabledClasses : disabledClasses, enabled ? disabledClasses : enabledClasses);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh, { passive: true });
      window.setTimeout(refresh, 100);
      refresh();
    });
  }

  /* ----------------------------------------------------------------
   * Plynne przewijanie do kotwic na tej samej stronie
   * ---------------------------------------------------------------- */
  function initAnchors() {
    if (document.documentElement.dataset.omAnchorsReady === 'true') return;
    document.documentElement.dataset.omAnchorsReady = 'true';

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"], [data-om-scroll-to]');
      if (!link) return;

      var target = link.getAttribute('data-om-scroll-to') || link.getAttribute('href');
      if (!target || target === '#' || target.charAt(0) !== '#') return;

      var element = document.getElementById(target.slice(1));
      event.preventDefault();
      if (!element) return; // taki sam efekt jak w Reakcie: brak celu = brak akcji
      element.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });

    // Wejscie na strone z hashem w adresie (odpowiednik <ScrollToTop />)
    if (window.location.hash) {
      var el = document.getElementById(window.location.hash.slice(1));
      if (el) {
        window.setTimeout(function () {
          el.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        }, 100);
      }
    }
  }

  /* ----------------------------------------------------------------
   * Start
   * ---------------------------------------------------------------- */
  function init(root) {
    var scope = root || document;
    initNavbar(scope);
    initStickyBar(scope);
    initScrollIndicator(scope);
    initReveals(scope);
    initCarousels(scope);
  }

  function boot() {
    initAnchors();
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Edytor motywu Shopify: sekcja przeladowana => podepnij zachowania na nowo
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    onScroll();
  });
})();
